class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector('[data-recommendations]');
    if (!recommendations) return;

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fetched = doc.querySelector('[data-recommendations]');
        if (!fetched || !fetched.innerHTML.trim()) return;

        recommendations.innerHTML = fetched.innerHTML;
        this.classList.remove('hidden');
      })
      .catch(() => {});
  }
}

customElements.define('cart-recommendations', CartRecommendations);
